module.exports = __webpack_public_path__ + "img/20-s.d470da7a.png";